/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProjectShareDto } from '../models/work-create-project-share-dto';
import { WorkProjectShareDto } from '../models/work-project-share-dto';
import { WorkProjectShareOptionsDto } from '../models/work-project-share-options-dto';
import { WorkUpdateProjectShareDto } from '../models/work-update-project-share-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectSharesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectSharesV2ControllerFindAllByProjectId()` */
  static readonly ProjectSharesV2ControllerFindAllByProjectIdPath = '/v2/project-shares/by-project/{projectId}';

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesV2ControllerFindAllByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerFindAllByProjectId$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectShareDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesV2Service.ProjectSharesV2ControllerFindAllByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectShareDto>>;
      })
    );
  }

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesV2ControllerFindAllByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerFindAllByProjectId(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectShareDto>> {
    return this.projectSharesV2ControllerFindAllByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectShareDto>>): Array<WorkProjectShareDto> => r.body)
    );
  }

  /** Path part for operation `projectSharesV2ControllerCreate()` */
  static readonly ProjectSharesV2ControllerCreatePath = '/v2/project-shares/by-project/{projectId}';

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSharesV2ControllerCreate$Response(
    params: {
      projectId: number;
      body: WorkCreateProjectShareDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectShareDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesV2Service.ProjectSharesV2ControllerCreatePath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectShareDto>;
      })
    );
  }

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSharesV2ControllerCreate(
    params: {
      projectId: number;
      body: WorkCreateProjectShareDto
    },
    context?: HttpContext
  ): Observable<WorkProjectShareDto> {
    return this.projectSharesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectShareDto>): WorkProjectShareDto => r.body)
    );
  }

  /** Path part for operation `projectSharesV2ControllerGetOptions()` */
  static readonly ProjectSharesV2ControllerGetOptionsPath = '/v2/project-shares/by-project/{projectId}/options';

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesV2ControllerGetOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerGetOptions$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectShareOptionsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesV2Service.ProjectSharesV2ControllerGetOptionsPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectShareOptionsDto>;
      })
    );
  }

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesV2ControllerGetOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerGetOptions(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectShareOptionsDto> {
    return this.projectSharesV2ControllerGetOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectShareOptionsDto>): WorkProjectShareOptionsDto => r.body)
    );
  }

  /** Path part for operation `projectSharesV2ControllerRemove()` */
  static readonly ProjectSharesV2ControllerRemovePath = '/v2/project-shares/{id}';

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesV2ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerRemove$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesV2Service.ProjectSharesV2ControllerRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesV2ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerRemove(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectSharesV2ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectSharesV2ControllerUpdate()` */
  static readonly ProjectSharesV2ControllerUpdatePath = '/v2/project-shares/{id}';

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSharesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateProjectShareDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectShareDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesV2Service.ProjectSharesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectShareDto>;
      })
    );
  }

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectSharesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateProjectShareDto
    },
    context?: HttpContext
  ): Observable<WorkProjectShareDto> {
    return this.projectSharesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectShareDto>): WorkProjectShareDto => r.body)
    );
  }

  /** Path part for operation `projectSharesV2ControllerRegeneratePin()` */
  static readonly ProjectSharesV2ControllerRegeneratePinPath = '/v2/project-shares/{id}/regenerate-pin';

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectSharesV2ControllerRegeneratePin()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerRegeneratePin$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectShareDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectSharesV2Service.ProjectSharesV2ControllerRegeneratePinPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectShareDto>;
      })
    );
  }

  /**
   * Required permissions: project-shares:update, project-shares:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectSharesV2ControllerRegeneratePin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectSharesV2ControllerRegeneratePin(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectShareDto> {
    return this.projectSharesV2ControllerRegeneratePin$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectShareDto>): WorkProjectShareDto => r.body)
    );
  }

}
